import React from "react";
import { DatavizMap } from "@radarly/models/dataviz";
import { SearchFragmentGeo } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsGeoMapProps {
  project: number;
  fragment: SearchFragmentGeo;
  onClickItem?: (uid: string | number) => void;
  dataviz: DatavizMap;
  forceReload?: boolean;
  className?: string;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsGeoMap({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickItem,
  ...props
}: SharedWidgetsGeoMapProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickItem = (uid: string | number) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickItem(uid);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        data={data}
        fragment={fragment}
        onClickItem={_onClickItem}
        {...props}
      />
    </Loading>
  );
}
